import {
    Component, ElementRef, EventEmitter, Input, OnInit, Output, QueryList, ViewChild, ViewChildren,
    ViewEncapsulation
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from '../../../../common/components/base.component';
import { HubTour } from '../../../../models/hub/hub.tour';
import { ImageService } from '../../../../services/image.service';

@Component({
    selector: 'ig-visitor-tour-card',
    templateUrl: './visitor.tour.card.component.html',
    styleUrls: ['./visitor.tour.card.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class VisitorTourCardComponent extends BaseComponent implements OnInit {
    public hubName: string;
    public isShowDescription = false;
    public isLoading = false;
    @Input() public tour: HubTour;
    @Input() public titleBgColor = '#23c6a0';
    @ViewChildren('card') card: QueryList<ElementRef>;
    @ViewChild('title') title: ElementRef;
    @Output() public showDetail = new EventEmitter<any>();

    constructor(private router: Router,
                private activatedRoute: ActivatedRoute,
                public imageService: ImageService,) {
        super({activatedRoute});
    }

    public ngOnInit() {
        let {hubName} = this.allRouteParams;
        this.hubName = hubName;
    }

    public showTourDetail($event) {
        this.showLoading();
        $event.stopPropagation();
        this.showDetail.emit(this.tour);
    }

    public mouseEnter() {
        this.isShowDescription = true;
    }

    public mouseLeave() {
        this.isShowDescription = false;
        // / setTimeout(() => {
        //     this.isShowDescription = false;
        // }, 500);
    }

    private showLoading() {
        this.isLoading = true;
        setTimeout(() => {
            this.isLoading = false;
        }, 2000);
    }
}


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/trip/tour.card/visitor.tour.card.component.ts